import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, firstValueFrom, map } from 'rxjs';
import { Login } from '../models/login';
import { User } from '../models/user.model';
import { LoginRepository } from '../repositories/login.repository';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private router: Router,
    private loginRepositoryHttp: LoginRepository,
    private localStorageService: LocalStorageService,
  ) {}

  /**
   * Logs the user into UI
   *
   * @param username Username
   * @param password Password
   * @returns User login response stream
   */
  login(username: string, password: string): Observable<Login> {
    return this.loginRepositoryHttp.login(username, password).pipe(
      map((response) => {
        this.localStorageService.setToken(response.headers.get('set-cookie'));
        return response.body;
      }),
    );
  }

  isTokenValid(): boolean {
    return this.localStorageService.isTokenValid();
  }

  /**
   * Returns the token if the token is valid
   * @returns string
   */
  getToken(): string | undefined {
    return this.localStorageService.getToken();
  }

  setUser(user: User) {
    this.localStorageService.setUser(user);
  }

  getUser(): User {
    return this.localStorageService.getUser();
  }

  async logout(token: string): Promise<boolean> {
    try {
      await firstValueFrom(
        this.loginRepositoryHttp.logout(token).pipe(
          map((res) => {
            this.localStorageService.clearToken();
            return res.body;
          }),
        ),
      );
    } catch (error) {
      console.error(error);
    }
    this.localStorageService.removeAll();
    return this.router.navigateByUrl('/login');
  }
}
